import React, { useContext, useState } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import Menu from './Menu.jsx';
import EditMenu from './EditMenu.jsx';
import VendorProvider, { VendorContext } from '../providers/Vendor.jsx';
import Orders from './Orders.jsx';
import BusinessHours from './BusinessHours.jsx';
import { s } from '../Style.jsx';

const Providers = () => (
    <VendorProvider>
        <Vendor />
    </VendorProvider>
);
export default Providers;

const Vendor = () => {

    const { authorizing, person } = useContext(PersonContext);
    const { vendor, setVendor, vendors, refreshVendor } = useContext(VendorContext);
    const [screen, setScreen] = useState("Orders");

    return <div>
        {person?.roles && person.roles.includes("vendor") && <>
            <div style={{ ...s.headerBox, marginBottom: 20 }}>
                <div style={s.headerInnerBox}>
                    <div style={{ ...s.row, maxWidth: 500 }}>
                        <div>
                            <h1 style={{ marginBottom: 0 }}><i className="fas fa-store"></i> Client Dashboard</h1>
                            {
                                //if the user has more than one vendor, list them
                                !!(vendors?.length > 1) && <select
                                    style={{ ...s.input, width: 200, marginLeft: 10 }}
                                    value={vendor.id}
                                    onChange={e => {
                                        setVendor({});
                                        refreshVendor(e.target.value);
                                        setScreen("Orders");
                                    }}>
                                    {vendors.map(v => <option key={v.id} value={v.id}>{v.address}</option>)}
                                </select>
                            }
                            <Menu setScreen={setScreen} screen={screen} vendor={vendor} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={s.paddingContainer}>
                <div style={s.mobileContainer}>
                    {screen === "Orders" && <Orders setScreen={setScreen} screen={screen} />}
                    {vendor.enableMenus && screen === "EditMenu" && <EditMenu setScreen={setScreen} screen={screen} />}
                    {screen === "Business Hours" && <BusinessHours setScreen={setScreen} screen={screen} />}
                </div>
            </div>
        </>}
    </div>;

}